<template>
  <div id="hourly" class="container">
    <p>{{ place }} -- {{ date() }}</p>
    <div class="row">
      <div
        v-for="(hour, idx) in givenDaysHours.slice(0, 24)"
        :key="idx"
        class="eachHour col-4"
      >
        <div>{{ hourTime(hour.dt) }}</div>
        <div>Temp: {{ hour.temp.toFixed(1) }}</div>
        <img
          class="currentIcon"
          :src="hourlyImgSrc(hour)"
          :alt="hour.weather[0].description"
          :title="hour.weather[0].description"
        />
        <div>Conditions: {{ hour.weather[0].description }}</div>
      </div>
      <div v-if="leftOvers() < 24" class="col-12">
        <div class="col-12 blanks" v-for="idx in leftOvers()" :key="idx">
          <div v-if="idx === 1" style="color: lightcoral">
            No Further Current Data Available
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import OpenWeatherService from "../services/OpenWeatherService";
import Geocoder from "../services/Geocoder";
import moment from "moment";

export default {
  name: "HourlyWeather",
  data() {
    return {
      weather: { hourly: [] },
      hourly: [{ weather: [] }],
      place: ""
    };
  },
  props: {
    secs: {
      type: Number,
      default: moment().valueOf()
    }
  },
  methods: {
    date() {
      return moment(this.secs).format("ddd, MMM Do, YYYY");
    },
    hourlyImgSrc(hour) {
      return (
        "http://openweathermap.org/img/wn/" + hour.weather[0].icon + ".png"
      );
    },
    testTomorrow() {
      return (
        moment()
          .add(1, "day")
          .valueOf() / 1000
      );
    },
    hourTime(sec) {
      if (sec) {
        return moment(sec * 1000).format("hh:ss A");
      } else {
        return "unknown";
      }
    },
    beginningOfDay(sec) {
      //console.log(sec);
      if (sec) {
        return (
          moment(sec)
            .startOf("day")
            .valueOf() / 1000
        );
      } else {
        return (
          moment()
            .startOf("day")
            .valueOf() / 1000
        );
      }
    },
    leftOvers() {
      const num =
        24 -
        this.hourly
          .filter(h => h.dt > this.beginningOfDay(this.secs))
          .slice(0, 24).length;
      //console.log("Num: " + num);
      if (num === 0) {
        return num;
      }
      const ret = Math.floor(num / 3);
      //console.log(ret);
      return ret;
    },
    endOfDay(sec) {
      if (sec) {
        return (
          moment(sec * 1000)
            .endOf("day")
            .valueOf() / 1000
        );
      } else {
        return (
          moment()
            .endOf("day")
            .valueOf() / 1000
        );
      }
    }
  },
  computed: {
    givenDaysHours() {
      return this.hourly.filter(h => h.dt > this.beginningOfDay(this.secs));
      //return this.hourly;
    }
  },
  async created() {
    const position = await OpenWeatherService.getCoordinates();
    await Geocoder.getCityState(position)
      .then(resp => {
        let town = resp.data.results[0].components.city;
        let state = resp.data.results[0].components.state;
        if (town === undefined) {
          town = resp.data.results[0].components.town;
        }

        this.place = town + ", " + state;
        //console.log(resp.data.results[0]);
      })
      .catch(err => console.log(err));
    await OpenWeatherService.getHourly(position)
      .then(response => {
        this.weather = response.data;

        this.hourly = this.weather.hourly;
      })
      .catch(err => console.log(err));

    // console.log(this.weather);
  }
};
</script>

<style scoped>
#hourly {
  font-weight: bolder;
}
.eachHour {
  /*margin: 2px;*/
  border: 2px solid black;
}
.blanks {
  height: 100px;
  text-align: center;
}
.currentIcon {
  border: 2px solid lightcoral;
  padding: 10px;
  border-radius: 50px 20px;
}
</style>
